import * as React from "react";
import type { SVGProps } from "react";
const SvgSave01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M6.6 20.4V15a1.2 1.2 0 0 1 1.2-1.2h8.4a1.2 1.2 0 0 1 1.2 1.2v6M15 7.2H7.8A1.2 1.2 0 0 1 6.6 6V2.4m14.397 4.197-3.594-3.594a2.06 2.06 0 0 0-1.455-.603H4.458A2.057 2.057 0 0 0 2.4 4.457v15.086c0 1.136.921 2.057 2.057 2.057h15.086a2.057 2.057 0 0 0 2.057-2.057V8.053c0-.547-.217-1.07-.603-1.456Z"
    />
  </svg>
);
export default SvgSave01;
